<template>
  <div>
    <field-group
      v-model="form.raster_type_id"
      :error-messages="errors.raster_type_id"
      :items="types.items"
      :loading="types.loading"
      :rules="typeRules"
      filled
      item-text="name"
      item-value="id"
      label="Loại ảnh viễn thám"
      no-label
      typeInput="v-autocomplete"
    ></field-group>
    <field-group
      v-model="form.raster_source_id"
      :error-messages="errors.raster_source_id"
      :items="sources.items"
      :loading="sources.loading"
      :rules="sourceRules"
      filled
      item-text="name"
      item-value="id"
      label="Nguồn dữ liệu"
      no-label
      typeInput="v-autocomplete"
    ></field-group>
    <div
      v-if="form.raster_source_id && !sources.loading && !selectedSource"
      class="mb-4 pa-3"
      style="background: #fff3e0"
    >
      <div class="text-body-2">
        Nguồn dữ liệu đã bị xóa hoặc không còn tồn tại. Vui lòng chọn nguồn
        khác.
      </div>
    </div>
    <div v-if="selectedSource" class="mb-4 pa-3" style="background: #f3f6f9">
      <div class="subtitle-2 mb-1">Thông tin nguồn dữ liệu</div>
      <div class="text-body-2 mb-1">
        <strong>Tên:</strong> {{ selectedSource.name }}
      </div>
      <div v-if="selectedSource.description" class="text-body-2 mb-2">
        <strong>Mô tả:</strong> {{ selectedSource.description }}
      </div>
      <div v-if="form.metadata && form.metadata.length">
        <field-group
          v-for="row in form.metadata"
          :key="row.id"
          v-model="row.value"
          :label="sourceFieldLabel(row.id)"
          filled
          dense
        ></field-group>
      </div>
      <div v-else class="text-caption grey--text">
        Nguồn dữ liệu này chưa có metadata.
      </div>
    </div>
  </div>
</template>

<script>
import { API_RASTER_SOURCE, API_RASTER_TYPE } from '@api'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    sourceRules: [],
    typeRules: [],
    sources: { loading: false, items: [] },
    types: { loading: false, items: [] },
  }),
  computed: {
    form() {
      return this.value
    },
    selectedSource() {
      const id = this.form && this.form.raster_source_id
      if (!id) return null
      return (
        this.sources.items.find((item) => String(item.id) === String(id)) ||
        null
      )
    },
  },
  watch: {
    selectedSource: {
      immediate: true,
      handler(source) {
        if (!this.form) return
        if (!this.form.raster_source_id) {
          this.$set(this.form, 'metadata', [])
          return
        }
        if (!source) return
        this.syncMetadataFromSource(source)
      },
    },
  },
  created() {
    this.fetchSources()
    this.fetchTypes()
  },
  methods: {
    sourceRows(source) {
      const metadata = source && source.metadata
      if (!Array.isArray(metadata)) return []
      return metadata
        .filter(
          (item) =>
            item &&
            String(item.id || '').trim() !== '' &&
            String(item.field || '').trim() !== ''
        )
        .map((item) => ({
          id: String(item.id).trim(),
          field: String(item.field).trim(),
          value: item.value != null ? item.value : '',
        }))
    },
    currentValueById() {
      const current = Array.isArray(this.form.metadata)
        ? this.form.metadata
        : []
      const map = {}
      current.forEach((row) => {
        if (row && String(row.id || '').trim() !== '') {
          map[String(row.id).trim()] = row.value
        }
      })
      return map
    },
    currentValueByField() {
      const current = Array.isArray(this.form.metadata)
        ? this.form.metadata
        : []
      const map = {}
      current.forEach((row) => {
        if (row && String(row.field || '').trim() !== '') {
          map[String(row.field).trim()] = row.value
        }
      })
      return map
    },
    sourceFieldLabel(id) {
      const row = this.sourceRows(this.selectedSource).find(
        (item) => String(item.id) === String(id)
      )
      return row ? row.field : ''
    },
    syncMetadataFromSource(source) {
      const currentById = this.currentValueById()
      const currentByField = this.currentValueByField()
      const next = this.sourceRows(source).map((row) => {
        let value = row.value
        if (Object.prototype.hasOwnProperty.call(currentById, row.id)) {
          value = currentById[row.id]
        } else if (
          Object.prototype.hasOwnProperty.call(currentByField, row.field)
        ) {
          value = currentByField[row.field]
        }
        return {
          id: row.id,
          value,
        }
      })
      this.$set(this.form, 'metadata', next)
    },
    async fetchSources() {
      this.sources.loading = true
      try {
        const res = await API_RASTER_SOURCE.list({
          sort: 'name',
          paginate: false,
        })
        this.sources.items = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.list) || []
      } finally {
        this.sources.loading = false
      }
    },
    async fetchTypes() {
      this.types.loading = true
      try {
        const res = await API_RASTER_TYPE.list({
          sort: 'name',
          paginate: false,
        })
        this.types.items = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.list) || []
      } finally {
        this.types.loading = false
      }
    },
  },
}
</script>
